import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate } from 'react-router-dom';

const columns = [
  {
    title: 'Point of Sale',
    dataIndex: 'pos_name',
    key: 'pos_name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'User',
    dataIndex: 'user',
    key: 'user',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Cashier',
    dataIndex: 'employee',
    key: 'employee',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Date',
    dataIndex: 'date',
    key: 'date',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Sales',
    dataIndex: 'sales',
    key: 'sales',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Expenses',
    dataIndex: 'expenses',
    key: 'expenses',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Momo',
    dataIndex: 'momo',
    key: 'momo',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Bank Transfer',
    dataIndex: 'bank',
    key: 'bank',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Cash In Hand',
    dataIndex: 'cash_in_hand',
    key: 'cash_in_hand',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/pos/sales-update/'+record.seo.replaceAll('/', '-')}>
        EDIT
      </Link>
    )
  }
]



const PosSalesUpdate = () => {
  const salesUpdate = useLoaderData();
  const navigate = useNavigate();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/pos/sales-update/'+record.seo.replaceAll('/', '-'))
    };
  }


  
  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'>Sales Update</h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/pos/sales-update/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={salesUpdate}
        columns={columns}
        pagination={false}
        rowKey={'seo'}
      />
    
    </div>
  )
}

export default PosSalesUpdate;